import { create } from 'zustand'

interface LoadingStore {
  requestIds: string[]
  addRequest: (id: string) => void
  removeRequest: (id: string) => void
}

export const useLoadingStore = create<LoadingStore>((set) => ({
  requestIds: [],
  addRequest: (id) =>
    set((state) => ({
      requestIds: state.requestIds.includes(id) ? state.requestIds : [...state.requestIds, id]
    })),
  removeRequest: (id) =>
    set((state) => ({
      requestIds: state.requestIds.filter((requestId) => requestId !== id)
    }))
}))
